<template>
    <div>
        <div class="coverimg" :class="{'hasvideo': topVideo.length > 2}">
            <!--<img v-if="topImageUrl" class="responsiveimg" :src="topImageUrl" alt="B2B IMAGE" title="TONE B2B"/>-->
            <img v-if="!topVideoUrl" class="responsiveimg" :src="topImageUrl" alt="B2B IMAGE" title="TONE B2B"/>
            <video v-if="topVideoUrl" class="responsiveimg" autoplay loop muted>
                <source :src="topVideoUrl" type="video/mp4" :poster="topImageUrl">
            </video>
            <i class="fa fa-play-circle" @click="openVideoModal('','Top')"></i>
            <a class="watchvideolink" href="javascript:" @click="openVideoModal('','Top')">Watch Video</a>
            <div class="container">
                <div class="row">
                <div class="col-sm-5">
                    <h1>{{topHeading}}</h1>
                    <p>{{topParaLine1}}</p>
                    <button v-bind:style="{ backgroundColor: getCorpButtonColor, borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: this.getCorpButtonColor + ' !important', 'outline': 'none'}" class="btn btn-rounded btn-primary btn-lg" @click="scrollToFormSection()">Get Started</button>
                </div>
                </div>
            </div>
        </div>
        <div class="container showmobile">
            <div class="row">
                <div class="col-sm-12">
                    <h1>{{topHeading}}</h1>
                    <p>{{topParaLine1}}</p>
                    <button v-bind:style="{ backgroundColor: getCorpButtonColor, borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: this.getCorpButtonColor + ' !important', 'outline': 'none'}" class="btn btn-rounded btn-primary btn-lg" @click="scrollToFormSection()">Get Started</button>
                </div>
            </div>
        </div>

        <!-- FULL WIDTH  / FAST, FRESH, AUTHENTIC -->
        <div class="pannelsection">
            <div class="container">
                <div class="row">
                    <div class="col-sm-12">
                        <h2>{{panelsHeading}}</h2>
                    </div>
                </div>

            </div>
            <div class="card-container benefit-panel-bg">
                <!-- div class="flexow row centericons" -->
                    <div class="col-sm"> <!-- NEW 12/26/2025 -->
                        <div class="card1 fast">
                            <h2 class="auth-title">Fast</h2>
                            <p class="auth-text">
                                Our content is easy to digest. Short, microlearning videos have proven
                                to yield 145% better retention than traditional methods. With 24/7
                                on-demand on-the-go access, TONE is built for today’s schedules and
                                shorter attention spans.
                            </p>
                        </div>
                    </div> <!-- NEW 12/26/2025 -->

                    <div class="col-sm"> <!-- NEW 12/26/2025 -->
                        <div class="card1 fresh">
                            <h2 class="auth-title">Fresh</h2>
                            <p class="auth-text">
                                Our content is relevant. And that’s why it works. Unlike canned corporate
                                training videos, we continuously produce original content that addresses
                                current topics as they emerge resulting in 82% of employees engaging
                                once a month, even after a year.
                            </p>
                        </div>
                    </div> <!-- NEW 12/26/2025 -->

                    <div class="col-sm"> <!-- NEW 12/26/2025 -->
                        <div class="card1 authentic">
                            <h2 class="auth-title">Authentic</h2>
                            <p class="auth-text">
                                Our content is real. We’ve cultivated a powerful network of over 150
                                credentialed experts who tell it like it is. We drive conversations
                                that candidly explore real-world challenges, share experiences and
                                insights, and provide practical takeaways.
                            </p>
                        </div>
                    </div> <!-- NEW 12/26/2025 -->


                <!-- /div --> <!-- div class="flexow row centericons" -->
            </div>
        </div>

        <div class="Videoscarosal" v-if="b2bVideos">
            <div class="container">
                <h2>{{videosHeading}}</h2>
                <div class="slider responsive-slick-display-videos">
                    <div class="slide-player" v-for="video in b2bVideos">
                        <img class="jw-img" :src="video.image" @click="openVideoModal(video, 'Regular')" :alt="video.description" :title="video.title" />
                        <p @click="openVideoModal(video, 'Regular')" class="text-wrap-title cursor">
                            {{video.title}}
                            <small>{{video.description}}</small>
                        </p>
                    </div>
                </div>
            </div>
            <!-- video carosal here -->
        </div>

        <div class="pannelsection">
            <div class="container">
                <!-- div class="row" -->
                <div class="col-sm-12">
                    <h2>Real Results</h2>
                </div>
                <!-- /div -->
            </div>
            <div class="benefit-panel benefit-panel-bg">
                <!-- class="dashboard" -->
                <!-- div class="flexow row centericons" -->
                <div class="row">
                    <!-- TOP STAT CARDS -->
                    <div class="stats-row">
                        <div class="stat-card">
                            <div class="stat-value">96%</div>
                            <div class="stat-label">Want to renew<br>after one year</div>
                        </div>

                        <div class="stat-card">
                            <div class="stat-value">95%</div>
                            <div class="stat-label">Customer<br>renewal rate</div>
                        </div>

                        <div class="stat-card">
                            <div class="stat-value">98%</div>
                            <div class="stat-label">Engagement<br>rate</div>
                        </div>

                        <div class="stat-card">
                            <div class="stat-value">74%</div>
                            <div class="stat-label">World-class Net<br>Promoter Score</div>
                        </div>
                    </div>

                    <!-- BOTTOM DONUT METRICS -->
                    <div class="bottom-row">

                        <div class="metric">
                            <!-- div class="donut" style="--percent: 295deg;" -->
                            <div class="donut" :style="donut1value">
                                <span>82%</span>
                            </div>
                            <div class="metric-text">
                                ENGAGE ONCE A MONTH<br>
                                EVEN AFTER A YEAR
                            </div>
                        </div>

                        <div class="metric">
                            <div class="donut" :style="donut2value">
                                <span>50%</span>
                            </div>
                            <div class="metric-text">
                                MORE LIKELY TO STAY<br>
                                AT THEIR COMPANY
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="logoscarosal">
            <div class="container">
                <h2>{{logosHeading}}</h2>
                <div class="slider responsive-slick-display-logos">
                    <div class="slide-player" v-for="logo in corpLogos">
                        <a :href="logo.linkDestination" target="_blank"><img :src="logo.logoUrl" alt="CORP LOGO" :title="logo.siteNameText"/></a>
                    </div>
                    </div>
                </div>
        </div>
        <div class="testimonialscarosal" v-if="testimonials">
            <div class="container">
                <h2>{{testimonialsHeading}}</h2>
                <div class="slider responsive-slick-display-testimonials">
                    <div class="slide-player" v-for="testimonial in testimonials">
                    <!-- <blockquote> -->
                        “{{testimonial.quote}}”
                        <div v-if="testimonial.author" class="author">--{{testimonial.author}}, {{testimonial.location}}--</div>
                    <!-- </blockquote> -->
                </div>
                </div>
            </div>
        </div>
        <!-- div class="contactformb2b" id="connectFormScroll">
            <div class="container">
                <h2>{{formHeading}}</h2>
                <p v-if="formLine1" v-html="formLine1"></p>
                <img v-if="showLinkedInCode" height="1" width="1" style="display:none;" alt="" src="https://px.ads.linkedin.com/collect/?pid=565489&conversionId=1460522&fmt=gif(43 B)
https://px.ads.linkedin.com/collect/?pid=565489&conversionId=1460522&fmt=gif
" />
                <div class="contact-form">
                    <div class="form">
                        <form id="contactus_form" v-on:submit.prevent="onSubmit">
                            <div class="row">
                                <div class="col-sm-6">
                                    <bs-input v-model="uName"
                                              type="text"
                                              class="form-input"
                                              error=""
                                              placeholder="Name"
                                              required
                                    >
                                    </bs-input>
                                </div>
                                <div class="col-sm-6">
                                    <bs-input v-model="companyName"
                                              type="text"
                                              class="form-input"
                                              error=""
                                              placeholder="Company Name"
                                    >
                                    </bs-input>
                                </div>
                                <div class="col-sm-6">
                                    <bs-input v-model="contactForm.emailAddress"
                                              v-bind:pattern="/\S+@\S+\.\S+/"
                                              type="email"
                                              class="form-input"
                                              error=""
                                              placeholder="Email Address"
                                              required
                                    >
                                    </bs-input>
                                </div>
                            </div>
                            <div>
                                <button v-bind:style="{ backgroundColor: getCorpButtonColor}" v-if="!spinner" class="btn formButton btn-transparent" id="contact_sendbutton">
                                    Request a Meeting
                                    <spinner v-if="spinner" v-model="spinner" size="lg" class="btn-spinner"></spinner>
                                </button>
                            </div>
                        </form>
                        <alert v-model="error.show" placement="top-right" duration="2000" type="danger" width="400px" dismissable>
                            <span class="icon-info-circled alert-icon-float-left"></span>
                            <strong>Error:</strong>
                            <p id="contactus_errormsg">{{error.message}}</p>
                        </alert>
                    </div>
                </div>
            </div>
        </div -->
        <div class="container hubspotHeading">
            <h2>{{formHeading}}</h2>
            <p v-if="formLine1" v-html="formLine1"></p>
        </div>
        <div class="hubspotForm">
            <div id="hubspotForm"></div>
        </div>
        <modal v-if="showB2BVideoModal" large class="watchVideoModal" effect="fade" :value="showB2BVideoModal" @cancel="cancelModal()">
            <div slot="modal-header" class="b2bVideoModal">
                <a href="javascript:" @click="cancelModal()">
                    <img class="watchVideoArrow" src="../assets/watch-video-arrow.png" alt="CLOSE">
                </a>
            </div>
            <div slot="modal-body" class="modal-body">
                <jwplayer :data="currentVideoPlayer" autoplay controls>Loading the player...</jwplayer>
                <!--<p>-->
                    <!--{{currentVideoPlayer.videoDescription}}-->
                <!--</p>-->
            </div>
            <div slot="modal-footer">
                <button class="btn btn-rounded btn-primary btn-lg" v-bind:style="{ backgroundColor: getCorpButtonColor, borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: this.getCorpButtonColor + ' !important', 'outline': 'none'}" @click="cancelModal();scrollToFormSection();">Get Started</button><br>
            </div>
        </modal>
    </div>
</template>

<script>
    import jwplayer from './JwPlayer.vue'
    import { input, spinner, alert, modal } from 'vue-strap'
    import { mapGetters } from 'vuex'
    import MaskedInput from 'vue-masked-input'
    import $ from 'jquery'
    import slick from 'slick-carousel'
    import { isMedianShell, shouldApplyMedianBottomTabBar, applyMedianNativeNavigationCommands } from '../helpers/medianNativeNavigation'

    export default {
        components: {
            'bs-input': input,
            'spinner': spinner,
            'alert': alert,
            'masked-input': MaskedInput,
            modal,
            jwplayer
        },
        metaInfo () {
            let self = this
            return {
                title: self.metaTag_pageTitle,
                meta: [
                    {name: 'keywords', content: self.metaTag_keywords},
                    {name: 'description', content: self.metaTag_description},
                    {property: 'og:image', content: self.metaTag_fb_image},
                    {property: 'og:title', content: self.metaTag_fb_title},
                    {property: 'og:site_name', content: self.metaTag_fb_sitename},
                    {
                        property: 'og:description',
                        content: self.metaTag_fb_description
                    },
                    {property: 'twitter:title', content: self.metaTag_tw_title},
                    {property: 'twitter:card', content: 'summary'},
                    {property: 'twitter:image', content: self.metaTag_tw_image},
                    {
                        property: 'twitter:description',
                        content: self.metaTag_tw_description
                    },
                    {property: 'og:image:width', content: '300'},
                    {property: 'og:image:height', content: '300'}
                ]
            }
        },
        name: 'login',
        data: function () {
            return {
                success: false,
                successMsg: '',
                uName: '',
                companyName: '',
                companyDescription: '',
                rawPhoneNumber: '',
                b2bComments: '',
                companySize: '',
                contactForm: {
                    emailAddress: '',
                    phoneNumber: '',
                    reason: '',
                    comments: ''
                },
                showB2BVideoModal: false,
                currentVideoPlayer: null,
                spinner: false,
                topImageUrl: '',
                topHeading: '',
                topParaLine1: '',
                topParaLine2: '',
                topParaBullet1: '',
                topParaBullet2: '',
                topParaBullet3: '',
                vidSectionImage: '',
                vidSectionHeading: '',
                vidSectionText: '',
                contSectionImage: '',
                contSectionHeading: '',
                contSectionText: '',
                evtSectionImage: '',
                evtSectionHeading: '',
                evtSectionText: '',
                collSectionImage: '',
                collSectionHeading: '',
                collSectionText: '',
                topVideo: '',
                topVideoObj: null,
                bottomPara: '',
                videoList: '',
                formLine1: '',
                formLine2: '',
                panelsHeading: '',
                videosHeading: '',
                logosHeading: '',
                testimonialHeading: '',
                formHeading: '',
                metaTag_pageTitle: 'TONE Networks for Businesses',
                metaTag_description: '',
                metaTag_keywords: '',
                metaTag_fb_image: '',
                metaTag_fb_title: '',
                metaTag_fb_description: '',
                metaTag_fb_sitename: '',
                metaTag_tw_image: '',
                metaTag_tw_title: '',
                metaTag_tw_description: '',
                testimonials: [],
                corpLogos: [],
                b2bVideos: [],
                showLinkedInCode: false,
                topVideoUrl: '',
                donut1degree: 295,
                donut2degree: 180,
                donut1value: '',
                donut2value: '',
                isNativeApp: false,
                isNativeAppNavigation: false,
                appNavigationURL: 'https://s3.amazonaws.com/tone-assets/app/navigation'
            }
        },
        computed: {
            ...mapGetters([
                'error', 'user', 'getAllSiteContents', 'getAllTestimonials', 'getCompanyLogos', 'getB2BVideos', 'getB2BTopVideo', 'getCorpButtonColor'
            ])
        },
        watch: {
            'topVideo' (to, from) {
                this.$store.dispatch('GET_B2B_VIDEOS_METADATA_TOPVIDEO', this.topVideo.replace(/\s/g, '').split(',')).then(() => {
                    if (this.getB2BTopVideo) {
                        let topVideo = this.getB2BTopVideo[0]
                        this.topVideoUrl = topVideo.sources[topVideo.sources.length - 1].file
                        console.log('top video object', this.topVideoUrl)
                    }
                })
            },
            'videoList' (to, from) {
                let self = this
                if (self.videoList) {
                    let videos = self.videoList.replace(/\s/g, '')
                    if (videos) {
                        let videosArray = videos.split(',')
                        if (videosArray && videosArray.length > 0) {
                            self.$store.dispatch('GET_B2B_VIDEOS_METADATA', videosArray).then(() => {
                                if (self.getB2BVideos) {
                                    self.b2bVideos = self.getB2BVideos
                                    setTimeout(() => {
                                        self.createVideos()
                                    }, 500)
                                }
                            })
                        }
                    }
                }
            }
        },
        mounted: function () {
            const script = document.createElement('script')
            script.src = 'https://js.hsforms.net/forms/v2.js'
            document.body.appendChild(script)
            script.addEventListener('load', () => {
                if (window.hbspt) {
                    window.hbspt.forms.create({
                        region: 'na1',
                        portalId: '9459028',
                        formId: 'a7b8f6c6-799e-46a9-b3eb-76528a228ec6',
                        target: '#hubspotForm'
                    })
                }
            })
            let self = this
            this.donut1value = '--percent: ' + this.donut1degree + 'deg;'
            this.donut2value = '--percent: ' + this.donut2degree + 'deg;'
            if (isMedianShell()) {
                this.isNativeApp = true
                this.isNativeAppNavigation = true
                const base = self.appNavigationURL
                const loadBottomTabs = shouldApplyMedianBottomTabBar()
                $.getJSON(`${base}/sidebar_unauth.json`, function (sidebarData) {
                    console.log('side navigation (unauth) returned', sidebarData)
                    if (loadBottomTabs) {
                        $.getJSON(`${base}/bottomNav_unauth.json`, function (tabsData) {
                            console.log('bottom navigation (unauth) returned', tabsData)
                            applyMedianNativeNavigationCommands({
                                sidebarItems: sidebarData,
                                tabsPayload: tabsData
                            })
                        }).fail(function (jqXHR, textStatus, errorThrown) { console.log('getJSON request failed! ' + textStatus + '  :  ' + errorThrown) })
                    } else {
                        applyMedianNativeNavigationCommands({ sidebarItems: sidebarData })
                    }
                }).fail(function (jqXHR, textStatus, errorThrown) { console.log('getJSON request failed! ' + textStatus + '  :  ' + errorThrown) })
            }
            self.$store.dispatch('GETDYNAMICCONTENTS', 14).then(() => {
                if (self.getAllSiteContents) {
                    this.metaTag_pageTitle = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_PAGE_TITLE')
                    this.metaTag_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_DESCRIPTION')
                    this.metaTag_keywords = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_KEYWORDS')
                    // OpenGraph Tags
                    this.metaTag_fb_title = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_TITLE')
                    this.metaTag_fb_image = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_IMAGE')
                    this.metaTag_fb_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_DESCRIPTION')
                    this.metaTag_fb_sitename = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_SITENAME')
                    // Twitter Tags
                    this.metaTag_tw_title = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_TITLE')
                    this.metaTag_tw_image = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_IMAGE')
                    this.metaTag_tw_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_DESCRIPTION')
                    // Top Section
                    self.topImageUrl = this.setDynamicSection(this.getAllSiteContents, 'TOP_IMAGE')
                    self.topVideo = this.setDynamicSection(this.getAllSiteContents, 'TOP_VIDEO_CODE')
                    // DELETE FOLLOWING 2 LINES AFTER RUNNING BELOW DB SCRIPT ON PROD DB
                    // self.topVideo = '3C4wsmYe'
                    self.topVideo = 'NlsJoAa3'
                    // UPDATE tonecore.dynamic_page_contents SET content_value = '3C4wsmYe ' WHERE pk_dynamic_page_contents_id = 390;
                    self.topHeading = this.setDynamicSection(this.getAllSiteContents, 'TOP_HEADING')
                    self.videoList = this.setDynamicSection(this.getAllSiteContents, 'CSV_VIDEO_CODE')
                    self.topParaLine1 = this.setDynamicSection(this.getAllSiteContents, 'TOP_PARA_LINE_01')
                    self.topParaLine2 = this.setDynamicSection(this.getAllSiteContents, 'TOP_PARA_LINE_02')
                    self.topParaBullet1 = this.setDynamicSection(this.getAllSiteContents, 'TOP_PARA_BULLET_01')
                    self.topParaBullet2 = this.setDynamicSection(this.getAllSiteContents, 'TOP_PARA_BULLET_02')
                    self.topParaBullet3 = this.setDynamicSection(this.getAllSiteContents, 'TOP_PARA_BULLET_03')
                    self.panelsHeading = this.setDynamicSection(this.getAllSiteContents, 'PANELS_HEADING')
                    self.videosHeading = this.setDynamicSection(this.getAllSiteContents, 'VIDEOS_HEADING')
                    self.testimonialsHeading = this.setDynamicSection(this.getAllSiteContents, 'TESTIMONIAL_HEADING')
                    self.logosHeading = this.setDynamicSection(this.getAllSiteContents, 'LOGOS_HEADING')
                    self.formHeading = this.setDynamicSection(this.getAllSiteContents, 'FORM_HEADING')
                    // Particular Sections
                    // Video Section
                    self.vidSectionImage = this.setDynamicSection(this.getAllSiteContents, 'COL_VIDEO_IMG_URL')
                    self.vidSectionHeading = this.setDynamicSection(this.getAllSiteContents, 'COL_VIDEO_HEADING')
                    self.vidSectionText = this.setDynamicSection(this.getAllSiteContents, 'COL_VIDEO_TEXT')
                    // Content Section
                    self.contSectionImage = this.setDynamicSection(this.getAllSiteContents, 'COL_CONTENT_IMG_URL')
                    self.contSectionHeading = this.setDynamicSection(this.getAllSiteContents, 'COL_CONTENT_HEADING')
                    self.contSectionText = this.setDynamicSection(this.getAllSiteContents, 'COL_CONTENT_TEXT')
                    // Event Section
                    self.evtSectionImage = this.setDynamicSection(this.getAllSiteContents, 'COL_EVENT_IMG_URL')
                    self.evtSectionHeading = this.setDynamicSection(this.getAllSiteContents, 'COL_EVENT_HEADING')
                    self.evtSectionText = this.setDynamicSection(this.getAllSiteContents, 'COL_EVENT_TEXT')
                    // Collection Section
                    self.collSectionImage = this.setDynamicSection(this.getAllSiteContents, 'COL_COLLECT_IMG_URL')
                    self.collSectionHeading = this.setDynamicSection(this.getAllSiteContents, 'COL_COLLECT_HEADING')
                    self.collSectionText = this.setDynamicSection(this.getAllSiteContents, 'COL_COLLECT_TEXT')
                    // Bottom Paragraph
                    self.bottomPara = this.setDynamicSection(this.getAllSiteContents, 'BOTTOM_PARA')
                    // Form Lines
                    self.formLine1 = this.setDynamicSection(this.getAllSiteContents, 'FORM_DESCRIPTION')
//                    self.formLine2 = this.setDynamicSection(this.getAllSiteContents, 'CONNECT_LINE_02')
                }
            })
            this.$store.dispatch('GETTESTIMONIALS', 'B2B').then(() => {
                if (this.getAllTestimonials) {
                    this.testimonials = this.getAllTestimonials
                    setTimeout(() => {
                        this.createTestimonail()
                    }, 500)
                }
            })
            this.$store.dispatch('GETCOMPANYLOGOS', 'B2B').then(() => {
                if (this.getCompanyLogos) {
                    this.corpLogos = this.getCompanyLogos
                    setTimeout(() => {
                        this.createLogos()
                    }, 500)
                }
            })
            setTimeout(() => {
//              this.videoList = 'lDakWO4P,5LTUcHGX,LePkt4e9,0aXXE0m0'
                self.$store.dispatch('CACHEPAGE', window.location.href)
            }, 2000)
        },
        methods: {
            openVideoModal (mainVideoObj, player) {
                if (player !== 'Top') {
                    this.currentVideoPlayer = {video: mainVideoObj.sources[mainVideoObj.sources.length - 1].file, title: mainVideoObj.title, img: mainVideoObj.image, playerID: new Date(), tracks: mainVideoObj.tracks, videoDescription: mainVideoObj.longdescription}
                    if (this.currentVideoPlayer) {
                        this.showB2BVideoModal = true
                    }
                } else {
                    this.$store.dispatch('GET_B2B_VIDEOS_METADATA', this.topVideo.replace(/\s/g, '').split(',')).then(() => {
                        if (this.getB2BVideos) {
                            this.topVideoObj = this.getB2BVideos[0]
                            this.currentVideoPlayer = {video: this.topVideoObj.sources[this.topVideoObj.sources.length - 1].file, title: this.topVideoObj.title, img: this.topVideoObj.image, playerID: new Date(), tracks: this.topVideoObj.tracks, videoDescription: this.topVideoObj.longdescription}
                            if (this.currentVideoPlayer) {
                                this.showB2BVideoModal = true
                            }
                        }
                    })
                }
            },
            cancelModal () {
                var self = this
                var $ = window.jQuery
                setTimeout(function () {
                    $('.modal-open').removeClass('modal-open')
                    this.currentVideoPlayer = null
                    self.showB2BVideoModal = false
                    /* remove the class added by default by modal, when open to retain the scrolling behaviour */
                }, 500)
            },
            scrollToFormSection () {
                // setTimeout(() => {
                //     $('html,body').animate({ scrollTop: $('#connectFormScroll').offset().top }, 800)
                // }, 1000)
                this.$router.push('/signup')
            },
            playVideoInPopup (mediaId) {
                console.log('media id', mediaId)
            },
            createTestimonail () {
                $.slick = slick
                const $charitySlick = $(this.$el).find('.responsive-slick-display-testimonials')
                $charitySlick.slick({
                    dots: false,
                    infinite: true,
                    speed: 1000,
                    arrows: false,
                    fade: true,
                    cssEase: 'linear',
                    autoplay: true,
                    autoplaySpeed: 4000,
                    useTransform: false,
                    adaptiveHeight: true,
                    pauseOnFocus: true,
                    pauseOnHover: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    responsive: [{
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            infinite: true,
                            dots: false
                        }
                    }, {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }, {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }]
                })
            },
            createLogos () {
                $.slick = slick
                const $logoSlick = $(this.$el).find('.responsive-slick-display-logos')
                $logoSlick.slick({
                    dots: false,
                    infinite: false,
                    speed: 300,
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    cssEase: 'linear',
                    responsive: [{
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true,
                            dots: false
                        }
                    }, {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }, {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }]
                })
            },
            createVideos () {
                $.slick = slick
                const $logoSlick = $(this.$el).find('.responsive-slick-display-videos')
                $logoSlick.slick({
                    dots: false,
                    infinite: false,
                    speed: 300,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    responsive: [{
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true,
                            dots: false
                        }
                    }, {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }, {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }]
                })
            },
            setDynamicSection (coll, key) {
                let valCol = coll.filter(x => {
                    return x.content_id === key
                })
                if (valCol && valCol.length > 0) {
                    return valCol[0].content_value
                } else {
                    return ''
                }
            },
            verifyEmail (email) {
                if (email.length > 0) {
                    let re = /\S+@\S+\.\S+/
                    if (!re.test(email)) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    return false
                }
            },
            spinnerToggle () {
                this.spinner = !this.spinner
            },
            onSubmit () {
                this.showLinkedInCode = false
                if (this.verifyEmail(this.contactForm.emailAddress)) {
                    this.b2bComments = 'Sent from B2B Page! '
                    let cDescription = this.companyDescription ? this.companyDescription : 'Not provided'
                    // let cSize = this.companySize ? this.companySize : 'Not provided'
                    this.b2bComments = this.b2bComments + ` User/Sender Name: ${this.uName}, Company Name: ${this.companyName}, Company Description: ${cDescription}`
                    this.contactForm.comments = this.b2bComments
                    this.spinnerToggle()
                    this.$store.dispatch('SENDCONTACTUSFORM', this.contactForm).then(() => {
                        this.spinnerToggle()
                        this.showLinkedInCode = true
                        window.fbq('track', 'Lead')
                        window.logEvents('B2B Page', 'Request a Demo Form', 'submit')
                        this.$swal({
                            title: 'Sent!',
                            text: 'Thank you! We will get back to you shortly',
                            type: 'success',
                            timer: 3000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(
                            function () {
                            },
                            // handling the promise rejection
                            function (dismiss) {
                                if (dismiss === 'timer') {
                                }
                            }
                        )
                    })
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hubspotForm {
    margin: 2% 10%;
    max-width: 80%;
}
.hubspotHeading {
   margin-top: 30px;
}
.testimonialscarosal .container {
    margin-bottom:-30px;
}
.content-style {
  text-align: left;
}
.content-style i {
  margin-right: 10px;
}
.real-results{
    padding: 40px;
}
.real-results span{
  font-size: 96px;
  color: #f0617d;
}
.real-results p{
  font-size: 16px;
}
#contactus_phonenumber {
    padding: 0 30px 0 15px;
    height: 60px;
    margin-bottom: 20px;
}
.contact-us-form p {
    font-size: 22px;
    font-family: sans-serif;
    letter-spacing: 0.5px;
    margin: 0 0 30px 0;
    font-weight: normal;
    line-height: 1;
    color: #777777;
}
.contact-us-form h2 {
    color: #f0617d;
    text-transform: capitalize;
    margin: 40px 0 15px 0;
    letter-spacing: 0.5px;
    font-family: sans-serif;
}

.responsiveimg {
    height: auto;
    width: 100%;
}

.b2bwrapper {}

.b2bwrapper {
    background: #eee;
}

.container.b2b {
    text-align: left;
}

.white {
    background: #fff;
    font-size: 18px;
    padding: 20px;
    margin: 30px 0;
}

.row.centericons img {
    margin: 0 auto 20px;
    display: block;
    width: 100px;
    height: 100px;
    object-fit: contain;
    object-position: center;
}

.row.centericons h4 {
    /* text-align: left; */
    font-weight: 500;
    font-size: 19px;
}

.row.centericons p {
    font-size: 16px;
}
.contactformholder {
    background: #666;
    color: #fff;
    padding: 20px;
}

button#contact_sendbutton {
    background: #f0617d;
    padding: 10px 50px;
    min-width: 220px;
    border-radius: 50px;
    margin: 20px auto 30px;
    font-size: 16px;
    font-weight: 900;
    color: #fff;
}

form#contactus_form {
    margin: 30px 0;
}
.b2b > h2 {
    font-weight: 900;
    font-family: 'Zilla Slab', serif !important;
}

.container.b2b {
    /* font-family: "Quicksand", sans-serif !important; */
}

.white {
    font-family: "Quicksand", sans-serif !important;
}

.contactformholder p{
    font-family: 'Zilla Slab', serif !important;
}

.contactformholder h2 {
    font-weight: 900;
    font-family: 'Zilla Slab', serif !important;
}
@media(min-width:768px){

    .row.centericons {
        display: flex;
    }
}
    @media(max-width:767px){
        .b2b > h2 {
            font-size: 21px;
        }

        .white {
            font-size: 16px !important;
        }
    }

.contactformholder a {
    font-weight: 900;
    color: #ffffff;
    text-decoration: underline;
    font-size: 19px;
}
@media(min-width:768px){
    .responsiveimg {
        max-height: 65vh;
        object-fit: cover;
    }

    .b2b > h2:first-of-type {
        position: absolute;
        top: 0;
        transform: translateY(-100%);
        margin: -20px 0 0;
        color: #fff;
        text-shadow: 0px 0px 4px #000;
    }

    .b2b {
        position: relative;
    }
}
.coverimg {
    position: relative;
}

.responsiveimg {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
}

.container.showmobile {
    display: none;
}


.coverimg {
    min-height: 65vh;
}

.coverimg {
    text-align: left;
    color: #fff;
}

.coverimg:after {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    z-index: 100;
    bottom: 0;
    knob
    background: rgba(0,0,0,1);
    background: -moz-linear-gradient(left, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 100%);
    background: -webkit-gradient(left top, right top, color-stop(0%, rgba(0,0,0,1)), color-stop(100%, rgba(0,0,0,0)));
    background: -webkit-linear-gradient(left, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 100%);
    background: -o-linear-gradient(left, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 100%);
    background: -ms-linear-gradient(left, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 100%);
    background: linear-gradient(to right, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#000000', endColorstr='#000000', GradientType=1 );
}

.coverimg .container {
    position: relative;
    z-index: 200;
}

button.btn.btn-rounded.btn-primary.btn-lg {
    border-radius: 50px;
    padding: 10px 40px;
}

.pannelsection {
    padding: 20px 0;
}

h2 {
    font-style: italic;
    margin: 10px 0 40px;
}

.Videoscarosal {
    padding: 40px 0;
    background: #eee;
}

.pannelsection, .testimonialscarosal {
    background: #eee;
    padding: 40px 0;
}


.contactformb2b h2:after ,
.logoscarosal h2:after {
    content: "";
    display: block;
    height: 2px;
    background: #f0617d;
    margin: 20px auto;
    max-width: 70px;
}

.contactformb2b {
    padding: 40px 0;
}

.contactformb2b p {
    font-size: 16px;
}
.ceniconholder {
    background: #fff;
    padding: 20px 20px 30px 20px;
    /* min-height: 380px; */
    /* border-radius: 20px; */
    /* box-shadow: 5px 5px 5px rgba(0 , 0, 0, 0.5); */
}

.logoscarosal {
    padding: 40px 0;
}

.logoscarosal img {
    width: 90%;
    height: auto;
    margin: 0 5%;
}

.testimonialscarosal blockquote {
    background-color: transparent;
    border: 0 none transparent;
    width: 100%;
    font-size: 24px;
}

html .testimonialscarosal .slide-player {
    background: transparent;
}

.testimonialscarosal blockquote .author {
    font-size: 16px;
    color: #000;
    margin: 10px 0 0;
}
.testimonialscarosal blockquote:before ,
.testimonialscarosal blockquote:after {
    color: #f0617d;
    font-size:150%;
    display:block;
    line-height:1;
    margin:0;
    padding:0;
}
.testimonialscarosal blockquote:before {
    content: '\201c';
}

.testimonialscarosal blockquote:after {
    content: '\201d';
    margin: 20px 0 0;
}

.coverimg i.fa.fa-play-circle {
    display:none;
}

.coverimg a.watchvideolink {
    display:none;
}
.coverimg.hasvideo i.fa.fa-play-circle {
    display:block;
    cursor: pointer;
}

.coverimg.hasvideo a.watchvideolink {
    display:block;
    cursor: pointer;
}
.coverimg.hasvideo i.fa.fa-play-circle {
    font-size: 50px;
    color: #fff;
    position: absolute;
    z-index: 500;
    left: 50%;
    top: 50%;
    transform: translate(-50% , -50%);
}

.coverimg.hasvideo a.watchvideolink {
    color: #fff;
    bottom: 20px;
    right: 20px;
    position: absolute;
    font-size: 21px;
    font-weight: bold;
    z-index: 500;
    text-decoration: none;
}

.coverimg {
    display: flex;
    align-items: center;
}

.coverimg  h1 {
    margin-top:0;
}

.row.centericons h4:before {
    content: "";
    display: block;
    height: 2px;
    width: 50px;
    margin: 20px auto;
    background: gray;
}

    @media(max-width:767px){
        .responsiveimg {
            position: static;
            height: auto;
            max-height: none;
        }

        .coverimg {
            height: auto;
            max-height: none;
            display: block;
            min-height: 0;
            line-height: 0;
        }

        .coverimg .container {
            display: none;
        }

        .container.showmobile{
            display: block;
            text-align: left;
        }

        .container.showmobile button.btn.btn-rounded.btn-primary.btn-lg {
            margin: 20px auto 30px;
            display: block;
        }
        .ceniconholder {
            margin: 0 0 30px;
        }
    }


.b2bVideoModal a{
    position: absolute;
    border: 1px solid #000;
    padding: 8px;
    border-radius: 50%;
    top: -20px;
    background: #fff;
    right: -20px;
}

.b2bVideoModal img {
    filter: brightness(0.0);
}

.watchVideoModal .modal-dialog .modal-body {
    padding: 20px;
}

.watchVideoModal .modal-dialog button.btn.btn-rounded.btn-primary.btn-lg {
    margin: 10px auto 40px;
}

.watchVideoModal > div {
    max-width: 500px;
}
@media(min-width:767px) and (max-width:992px){
    .coverimg .responsiveimg {
        min-height: 100% !important;
        max-height: 100% !important;
    }
}
@media(max-width:767px){
    .b2bVideoModal a {
        padding: 3px;
        top: -5px;
        right: -5px;
        line-height: 0;
        height: 23px;
        width: 23px;
        display: block;
        z-index: 500000000;
    }
    .b2bVideoModal a img {
        width: 15px;
    }
}
.flexow.row {
    display: flex;
}

.flexow.row .col-sm {
    padding: 10px;
    flex: 1;
}

.flexow.row .col-sm  .ceniconholder {
    height: 100%;
}
@media(max-width:767px){
    .flexow.row{
        flex-direction:column;
    }
}
</style>
<style>
    .contact-us-form .contact-form .form form .form-group textarea.form-control {
        max-height: 100px;
        min-height: 100px;
        min-width: 100%;
        max-width: 100%;
        width: 100% !important;
        height: 100px !important;
        resize: none;
    }
    .contactformb2b input.form-control, .contactformb2b #resetpassword_password {
        border-top: 0;
        border-left: 0;
        border-right: 0;
        box-shadow: 0 0 0 transparent;
    }

    .contactformholder .help-block.with-errors {
        position: absolute;
        color: #ffa2a2;
        bottom: -20px;
        font-size: 11px;
    }

    .contactformholder .form-group {
        padding-bottom: 5px;
    }

    html .logoscarosal .slide-player {
        margin: 0;
    }

    .logoscarosal .slick-track {
        margin: auto;
    }
    .Videoscarosal .slick-slide {
        padding: 0 15px;
    }

    html .Videoscarosal .slide-player {
        background: transparent;
    }

    html .Videoscarosal .slide-player p {
        text-align: center;
        line-height: 1.2;
        font-weight: normal;
        letter-spacing: unset;
    }
    html .Videoscarosal .slide-player p small {
        text-align: center;
        display:block;
        font-size:14px;
    }
    /*==================================== TT-1038, TT-1039 CHANGES BELOW ======================================= */
   /*
    * {
        box-sizing: border-box;
    }
    */

    .card {
        flex: 1;
        background: rgba(255, 255, 255, 0.25);
        border-radius: 12px;
        padding: 28px 26px;
        color: #0f2d3a;
        box-shadow: 0 12px 30px rgba(0, 0, 0, 0.15);
        backdrop-filter: blur(6px);
    }

    .card h2 {
        margin-top: 0;
        margin-bottom: 16px;
        font-size: 26px;
        font-weight: 700;
    }

    .card p {
        margin: 0;
        font-size: 15px;
        line-height: 1.6;
        color: #0e3a4a;
    }
    .card1.fresh {
        background: linear-gradient(
            160deg,
            #a7ddd2 0%,
            #6EC1E4 100%
        );
        box-shadow: 0 12px 28px rgba(0, 0, 0, 0.15);
    }

    /* Slight color variation per card */
    .card1.fast {
        background: linear-gradient(
            160deg,
            #a7ddd2 0%,
            #8fbcc4 100%
        );
    }

    .card1.authentic {
        background: linear-gradient(
            160deg,
            #a7ddd2 0%,
            #44bda8 100%
        );
    }

    /* Responsive */
    @media (max-width: 900px) {
        .container {
            flex-direction: column;
        }
    }

    .card1 {
        width: 360px;
        height: 360px;
        padding: 28px 26px;
        border-radius: 14px;
        flex: 1 1 calc(33.33% - 20px);
        /* padding: 20px; */
        box-sizing: border-box;
        background: lightgreen;
    }

    .auth-title {
        margin: 0 0 10px 0;
        font-size: 34px;
        font-weight: 700;
        color: #1f3b5b;
        letter-spacing: 0.2px;
        text-align: left;
    }

    .auth-text {
        margin: 0;
        font-size: 18px;
        line-height: 1.55;
        color: #223a56;
        text-align: left;
    }
    /* ----------------------------------------------------------------------------------------------- */

    .benefit-panel {
        display: flex;
        align-items: center;
        justify-content: center;
        /* background: linear-gradient(135deg, #004573, #44bda8); */
        padding: 20px 0;
    }

    .benefit-panel-bg {
        background: linear-gradient(135deg, #44bda8, #004573);
        padding: 20px 20px;
    }

    /* =====================
       TOP STATS CARDS
    ====================== */
    .stats-row {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 20px;
        margin-bottom: 50px;
    }

    .stat-card {
        background: #e9f6fb;
        border-radius: 8px;
        padding: 20px;
        text-align: center;
        color: #0b3c6d;
        border: 4px solid #5fb3e5;
    }

    .stat-value {
        font-size: 56px;
        font-weight: 700;
        margin-bottom: 10px;
    }

    .stat-label {
        font-size: 16px;
        font-weight: 600;
        text-transform: uppercase;
        line-height: 1.3;
    }

    /* =====================
       BOTTOM METRICS
    ====================== */
    .bottom-row {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 80px;
        align-items: center;
    }

    .metric {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 30px;
    }

    .metric-text {
        font-size: 18px;
        font-weight: 600;
        line-height: 1.4;
        color: #ffffff;
    }

    /* =====================
       DONUT CHARTS
    ====================== */
    .donut {
        width: 195px;
        height: 195px;
        border-radius: 50%;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        background: conic-gradient(
            #6ec1e4 0deg,               /* COVERED RING AREA SHOWING PERCENTAGE VALUE INSIDE RING  */
            #6ec1e4 var(--percent),     /* COVERED RING AREA SHOWING PERCENTAGE VALUE INSIDE RING - CAN BE DIFFERENT TO SHOW GRADIENT EFFECT */
            rgba(255,255,255,1) var(--percent),
                /* rgba(255,255,255,0.25) 360deg */  /* NON COVERED RING AREA SHOWING REMAINING PERCENTAGE VALUE INSIDE RING  */
                /* white 360deg */   /* NON COVERED RING AREA SHOWING REMAINING PERCENTAGE VALUE INSIDE RING  */
            rgba(255,255,255,1) 360deg
        );
    }

    .donut::before {
        content: "";
        width: 145px; /* WIDTH OF CIRCLE AROUND RING */
        height: 145px; /* HEIGHT OF CIRCLE AROUND RING */
        background: #0f4c75; /* COLOR OF CIRCLE INSIDE RING */
        border-radius: 50%;
        position: absolute;
    }

    .donut span {
        position: relative;
        /* font-size: 22px; */
        font-weight: 700;
        color: #6ec1e4; /* COLOR OF VALUE INSIDE RING */
        font-size: var(--donut-font-size, 48px);
    }

    /* =====================
       RESPONSIVE
    ====================== */
    @media (max-width: 900px) {
        .stats-row {
            grid-template-columns: repeat(2, 1fr);
        }

        .bottom-row {
            grid-template-columns: 1fr;
            gap: 40px;
        }
    }

    @media (max-width: 480px) {
        .stats-row {
            grid-template-columns: 1fr;
        }
    }
    /* ============================================================================ */
    .card-container {
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
        align-items: center;
        justify-content: center;
    }

    .card {
        flex: 1 1 calc(33.33% - 20px);
        padding: 20px;
        box-sizing: border-box;
        background: lightgreen;
        border-radius: 5px;
    }

    @media (max-width: 768px) {
        .card1 {
            flex: 1 1 calc(50% - 20px);
        }
    }

    @media (max-width: 480px) {
        .card1 {
            flex: 1 1 calc(100% - 20px);
        }
    }
</style>



// WEBPACK FOOTER //
// B2B.vue?dea61a5c